import { motion } from "framer-motion";
import { CTAButton } from "./CTAButton";
import { MAIN_IMAGE } from "../data/content";
export function Hero() {
  const goToCompra = () => {
    const el = document.getElementById("compra");
    if (el) el.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  };
  return <section className="px-5 pt-7" data-id="element-150" data-mp="4m8m0bnacpke">
      <motion.h1 initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="mx-auto max-w-[340px] text-center text-[27px] font-black leading-[1.06] tracking-[-0.035em] text-blue-950 sm:max-w-none sm:text-4xl" data-id="element-151" data-mp="4n9ymkjy9k48">
        Entrena Tu Mente Como Entrenas Tu Cuerpo
      </motion.h1>

      <motion.button type="button" onClick={goToCompra} initial={{
      opacity: 0,
      scale: 0.96
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.5,
      delay: 0.1
    }} aria-label="Ir a la sección de compra" className="mx-auto mt-5 block w-3/4 overflow-hidden rounded-3xl border border-blue-100 bg-white shadow-lg" data-id="element-152" data-mp="ncq1vfn0rqoc">
        <img src={MAIN_IMAGE} alt="Psicología Deportiva para Atletas — Sistema completo para mentes ganadoras" className="h-auto w-full" data-id="element-153" data-mp="3o7c0y05rgtho" />
      </motion.button>

      <p className="mt-6 text-center text-base font-medium leading-relaxed text-gray-700" data-id="element-154" data-mp="3e9607lvoxtee">
        Todo lo que necesitas para dejar de competir contra tu propia cabeza y
        empezar a rendir a tu verdadero nivel.
      </p>

      <div className="mt-5 flex flex-wrap items-center justify-center gap-2" data-id="element-155" data-mp="358zu4l2bnvp9">
        {["📄 100% PDF", "⚡️ Entrega inmediata", "💳 Pago único"].map(t => <span key={t} className="rounded-full border border-blue-100 bg-blue-50 px-3 py-1.5 text-xs font-semibold text-blue-800" data-id="element-156" data-mp="2viy1rh2xrr4j">
            {t}
          </span>)}
      </div>

      <div className="mt-6" data-id="element-157" data-mp="2lla6mq1f4hlu">
        <CTAButton data-id="element-158" data-mp="2ljgz78izdtcs" />
      </div>
    </section>;
}